// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d972b35c","703":"fdf750dc","787":"413f5b4c"}[chunkId] + ".chunk.js";
};